import ApiService from "@/common/api/api.service";

export const ProfileService = {

    get_days_off() {
        ApiService.setHeader()
        return ApiService.get('profile', 'days-off')
    },
    addDayOff(data) {
        ApiService.setHeader()
        return ApiService.post(`profile/days-off`, data)
    },
    deleteDayOff(id) {
        ApiService.setHeader()
        return ApiService.delete(`profile/days-off/${id}`)
    },
    get(slug) {
        ApiService.setHeader()
        return ApiService.get('profile', slug)
    },
    update(slug, data) {
        ApiService.setHeader()
        return ApiService.update('profile', slug, data)
    },
    get_logo(){
        ApiService.setHeader()
        return ApiService.getImageBlob('profile/logo')
    },
    save_logo(file){
        ApiService.setHeader()
        let formData = new FormData();
        formData.append("file", file);
        return ApiService.postFile('profile/logo', formData)
    },
    active() {
        ApiService.setHeader()
        return ApiService.update(`profile/active`)
    },
    inactive() {
        ApiService.setHeader()
        return ApiService.update(`profile/inactive`)
    },
    //post profile/logo form data
    //get profile/log 
    //post profile/days-off
    //get profile/days-off
    //delete profile/days-off/id
}